import type {ElementType} from 'react';

export function capitalizeFirstLetter(content: string | ElementType): string {
  // when testing translation gt() funcs return react elements
  // so here we convert them to string before capitalize
  const stringContent =
    typeof content !== 'string' ? content.toString() : content;

  return stringContent.charAt(0).toUpperCase() + stringContent.slice(1);
}
